const alt = require("AltInit");
const notificationActions = require("components/notification/NotificationActions");

const parseDao = require("actdao/ParseBaseDao");
const managementDao = require("actdao/ManagementDao");
const clubDao = require("actdao/ClubDao");
const parcoursDao = require("actdao/ParcoursDao");

const msgActions = require("actions/MessageActions");

class ManagementActions {

    initRequestParcoursManagePage(user, parcoursOwnerId) {
        /**
         * load parcours owner
         */
        parcoursDao.getParcoursOwner(parcoursOwnerId)
            .then(parcoursOwner => {
                /**
                 * load all management for user
                 */
                managementDao.getAllManagementsForUser(user)
                    .then(allManagements => {
                        this.updateAllManagements(allManagements);
                        // check if already managed or manageRequest was created
                        let mgmt = null;
                        for (let i = 0; i < allManagements.length; i++) {
                            if (allManagements[i].managesParcoursOwner(parcoursOwner) ||
                                allManagements[i].getManageRequestedIDParcoursOwner(parcoursOwner) != null) {
                                mgmt = allManagements[i];
                                break;
                            }
                        }
                        this.updateParcoursOwnerManager({
                            parcoursOwner: parcoursOwner,
                            management: mgmt
                        })
                    })
                    .catch(error => {
                        error.trace = "MGMA.loadMgmt4User";
                        notificationActions.parseError(error);
                    });
            })
            .catch(error => {
                error.trace = "MGMA.getParcoursOwner";
                notificationActions.parseError(error);
            });
        return {};
    }

    initBusinessRegisterPage(user, clubID) {
        clubDao
            .loadClubDetails(clubID)
            .then(pClubDetail => {
                managementDao.getForUser(user)
                    .then(management => {
                        this.initBusinessRegisterPageSuccess({
                            management: management,
                            club: pClubDetail
                        })
                    })
                    .catch(error => {
                        error.trace = "MGMA.loadMgmt4User";
                        notificationActions.parseError(error);
                    });
            })
            .catch(error => {
                error.trace = "MGMA.showCLubDetails";
                notificationActions.parseError(error);
            });
        return {};
    }

    initBusinessRegisterPageSuccess(data) {
        return data
    }

    updateParcoursOwnerManager(data) {
        return data;
    }

    register(address, features, callback) {
        managementDao.register(address, features)
            .then(management => {
                if (callback && typeof callback === 'function') {
                    callback(management);
                } else {
                    notificationActions.success("Anmeldung erfolgreich");
                    this.registerSuccess(management)
                }
            })
            .catch(error => {
                notificationActions.parseError(error)

            });
        return {};
    }

    registerSuccess(management) {
        return {management}
    }

    requestParcoursManagement(management, parcoursOwner) {
        managementDao.requestParcoursManagement(management, parcoursOwner)
            .then(management => {
                // slack info
                msgActions.slackCustomerNotify(management.getName() + " requestParcoursManagement für " + parcoursOwner.getName(), null, null);
                this.requestParcoursManagementSuccess(management);
            })
            .catch(error => {
                notificationActions.parseError(error)
            });
        return {};
    }

    requestClubManagement(management, club) {
        managementDao.requestClubManagement(management, club)
            .then(sManagement => {
                msgActions.slackCustomerNotify(management.getName() + " requestClubManagement für " + club.getName(), null, null);
                club.setManagementID(sManagement);
                parseDao.saveObject(club)
                    .then(sClub => {
                        this.initBusinessRegisterPageSuccess({
                            management: management,
                            club: sClub
                        })
                    })
                    .catch(error => {
                        error.trace = "MGMA.addManagement2Club";
                        notificationActions.parseError(error);
                    });
            })
            .catch(error => {
                error.trace = "MGMA.addManagement2Club";
                notificationActions.parseError(error);
            });
        return {};
    }

    requestParcoursManagementSuccess(management) {
        return function (dispatch) {
            managementDao
                .get(management.id)
                .then(
                    management => dispatch(management),
                    error => notificationActions.parseError(error)
                )
        }
    }

    cancelManagementRequest(management, managementRequest) {
        managementDao.cancelManagementRequest(management, managementRequest)
            .then(management => {
                    this.cancelManagementRequestSuccess()
                },
                error => notificationActions.parseError(error)
            )
    }

    cancelManagementRequestSuccess() {
        return null;
    }

    updateAllManagements(allManagements) {
        return allManagements
    }

}

module.exports = alt.createActions(ManagementActions);
